import { render, staticRenderFns } from "./orderDataTable.vue?vue&type=template&id=48ebed8b&"
import script from "./orderDataTable.vue?vue&type=script&lang=js&"
export * from "./orderDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports